export default __webpack_public_path__ + "static/media/cancelled.e9b3d16c.svg";